import React, { useEffect, useState } from "react";
import { fetchWhatsapp } from "../lib/api";

const WhatsAppIcon = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
    <path d="M20.52 3.48A11.78 11.78 0 0012.03 0C5.46 0 .13 5.33.13 11.9c0 2.1.55 4.15 1.6 5.96L0 24l6.31-1.66a11.86 11.86 0 005.71 1.46h.01c6.57 0 11.9-5.33 11.9-11.9 0-3.18-1.24-6.17-3.41-8.42zM12.04 21.3h-.01a9.4 9.4 0 01-4.8-1.32l-.34-.2-3.75.99 1-3.66-.22-.37a9.4 9.4 0 01-1.44-5 9.44 9.44 0 0116.11-6.68 9.37 9.37 0 012.77 6.69 9.44 9.44 0 01-9.32 9.55zm5.42-7.04c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.08-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.65-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.35.44-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37s-1.05 1.03-1.05 2.5 1.08 2.9 1.23 3.1c.15.2 2.12 3.24 5.14 4.55.72.31 1.28.5 1.72.64.72.23 1.37.2 1.89.12.58-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35z" />
  </svg>
);

export default function WhatsAppButton() {
  const [wa, setWa] = useState({ number: "", message: "" });

  useEffect(() => {
    fetchWhatsapp().then(setWa).catch(() => {});
  }, []);

  if (!wa.number) return null;

  const href = `https://wa.me/${wa.number.replace(/\D/g, "")}?text=${encodeURIComponent(
    wa.message || "Olá, Pr. Carlos!"
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-24 right-4 sm:bottom-6 sm:right-6 z-50 group"
    >
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-[#25D366]/40 blur-xl group-hover:bg-[#25D366]/60 transition" />
        <div className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-[#25D366]/30 group-hover:scale-105 transition-transform">
          <WhatsAppIcon className="w-7 h-7" />
        </div>
      </div>
    </a>
  );
}
